var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ls-flex grow-2" },
    [
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loading,
                expression: "!loading"
              }
            ],
            staticClass: "col-12"
          },
          [
            _c(
              "div",
              {
                key: "mainPanel",
                staticClass:
                  "panel panel-default col-12 question-option-general-container"
              },
              [
                _c("div", { staticClass: "panel-heading" }, [
                  _vm._v(_vm._s(_vm._f("translate")("Text elements")))
                ]),
                _c("div", { staticClass: "panel-body" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 ls-space margin all-5 scope-contains-ckeditor"
                    },
                    [
                      _c("div", { staticClass: "ls-flex-row" }, [
                        _c(
                          "div",
                          { staticClass: "ls-flex-item grow-2 text-left" },
                          [
                            _c("label", { staticClass: "col-sm-12" }, [
                              _vm._v(
                                _vm._s(_vm._f("translate")("Question")) + ":"
                              )
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "ls-flex-item text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default btn-xs",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleSourceEditQuestion($event)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-file-code-o" }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._f("translate")("Toggle source mode")
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ]),
                      !_vm.questionEditSource
                        ? _c("lsckeditor", {
                            attrs: {
                              editor: _vm.editorQuestionObject,
                              config: _vm.editorQuestionConfig
                            },
                            on: { input: _vm.runDebouncedChange },
                            model: {
                              value: _vm.currentQuestionQuestion,
                              callback: function($$v) {
                                _vm.currentQuestionQuestion = $$v
                              },
                              expression: "currentQuestionQuestion"
                            }
                          })
                        : _c("aceeditor", {
                            attrs: {
                              showLangSelector: false,
                              thisId: "questionEditSource"
                            },
                            on: { input: _vm.runDebouncedChange },
                            model: {
                              value: _vm.currentQuestionQuestion,
                              callback: function($$v) {
                                _vm.currentQuestionQuestion = $$v
                              },
                              expression: "currentQuestionQuestion"
                            }
                          })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 ls-space margin all-5 scope-contains-ckeditor"
                    },
                    [
                      _c("div", { staticClass: "ls-flex-row" }, [
                        _c(
                          "div",
                          { staticClass: "ls-flex-item grow-2 text-left" },
                          [
                            _c("label", { staticClass: "col-sm-12" }, [
                              _vm._v(_vm._s(_vm._f("translate")("Help")) + ":")
                            ])
                          ]
                        ),
                        _c("div", { staticClass: "ls-flex-item text-right" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-default btn-xs",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleSourceEditHelp($event)
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fa fa-file-code-o" }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm._f("translate")("Toggle source mode")
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ])
                      ]),
                      !_vm.helpEditSource
                        ? _c("lsckeditor", {
                            attrs: {
                              editor: _vm.editorHelpObject,
                              config: _vm.editorHelpConfig
                            },
                            on: { input: _vm.runDebouncedChange },
                            model: {
                              value: _vm.currentQuestionHelp,
                              callback: function($$v) {
                                _vm.currentQuestionHelp = $$v
                              },
                              expression: "currentQuestionHelp"
                            }
                          })
                        : _c("aceeditor", {
                            attrs: {
                              showLangSelector: false,
                              thisId: "helpEditSource"
                            },
                            on: { input: _vm.runDebouncedChange },
                            model: {
                              value: _vm.currentQuestionHelp,
                              callback: function($$v) {
                                _vm.currentQuestionHelp = $$v
                              },
                              expression: "currentQuestionHelp"
                            }
                          })
                    ],
                    1
                  ),
                  !!_vm.$store.state.currentQuestionPermissions.script
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "col-12 ls-space margin all-5 scope-contains-ckeditor"
                        },
                        [
                          _c("label", { staticClass: "col-sm-6" }, [
                            _vm._v(
                              "\n                                " +
                                _vm._s(_vm._f("translate")("Script")) +
                                ":\n                        "
                            )
                          ]),
                          _c("div", { staticClass: "col-sm-6 text-right" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.scriptForAllLanugages,
                                  expression: "scriptForAllLanugages"
                                }
                              ],
                              attrs: {
                                type: "checkbox",
                                name: "selector--scriptForAllLanguages",
                                id: "selector--scriptForAllLanguages"
                              },
                              domProps: {
                                checked: Array.isArray(
                                  _vm.scriptForAllLanugages
                                )
                                  ? _vm._i(_vm.scriptForAllLanugages, null) > -1
                                  : _vm.scriptForAllLanugages
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.scriptForAllLanugages,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.scriptForAllLanugages = $$a.concat(
                                          [$$v]
                                        ))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.scriptForAllLanugages = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.scriptForAllLanugages = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" \n                            "),
                            _c(
                              "label",
                              {
                                attrs: {
                                  for: "selector--scriptForAllLanguages"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm._f("translate")(
                                        "Set for all languages"
                                      )
                                    ) +
                                    "\n                            "
                                )
                              ]
                            )
                          ]),
                          _c("aceeditor", {
                            attrs: {
                              "show-lang-selector": false,
                              "base-lang": "javascript",
                              thisId: "helpEditScript",
                              showLangSelector: true
                            },
                            on: { input: _vm.runDebouncedChange },
                            model: {
                              value: _vm.currentQuestionScript,
                              callback: function($$v) {
                                _vm.currentQuestionScript = $$v
                              },
                              expression: "currentQuestionScript"
                            }
                          }),
                          _c("p", { staticClass: "alert well" }, [
                            _vm._v(_vm._s(_vm._f("translate")("__SCRIPTHELP")))
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
            ),
            _c("div", { key: "divideRow", staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 ls-space margin top-5 bottom-5" },
                [_c("hr")]
              )
            ])
          ]
        )
      ]),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c("loader-widget", {
                  attrs: { id: "mainQuestionGroupEditorLoader" }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }